/* eslint-disable */
import { ESETTINGS_KEYS, IUserInitialPosition, IUserSetting, IUserSpeedData } from "~/state/user/interfaces";
import { CONFIG } from "~/config";
import { getMapsetSeoById } from "~/util/mapset";
import { frpc } from "../general";
import { ICreateLikeData, IMapyBoxItem, TActivityType, TMyMapsSortOptions } from "~/interfaces";
import { store } from "~/state/store";
import { mymapsClearData, mymapsSetFoldersData, mymapsSetHasFolders } from "~/state/mymaps/state";
import { IMyMapsState } from "~/state/mymaps/interfaces";
import { watch, watchCurrentUser } from "~/state/util";

interface IFolderData {
	id: string;
	title: string;
}

interface ICopyOutput {
	copied: Array<{
		new_id: string;
		old_id: string;
	}>;
	status: number;
	statusMessage: string;
}

export interface IUserSettingsResponse {
	items?: Array<IUserSetting>;
	update_time?: number,
	status: number,
	statusMessage: string;
}

interface ILikeHints {
	[key: string]: string;
}

interface ICreateLikeOpts {
	duplicity?: "check" | "ignore";
}

interface ILikeMoveOpts {
	actualFolderId?: string;
}

export const OPTIONS = {
	// v [ms]
	folderDuration: 30000,
	baseDuration: 30000,
	url: "/mapybox-ng/",
};

const DEBUG_DATA = {
	enabled: false && location.href.indexOf("dev.dszn.cz") !== -1,
	fail: false,
	timeout: 500,
};

// @ts-ignore
window.mapyboxFail = (state: boolean) => {
	DEBUG_DATA.fail = state;
};

const LIMIT_ON_PAGE = 300;
/* sdilena slozka */
let folderData: IFolderData = null;
/* data uzivatelu */
const userInfoCache: {[key: string]: IMyMapsState} = {};
let currentRootId = "";

const watchUser = watch(store.getState, "user", watchCurrentUser);

store.subscribe(watchUser((newUser, oldUser) => {
	// odhlasil se, nebo se prepnul z uzivatele na uzivatele - vynulujeme stav, jinak ne
	if ((oldUser.user.userPublicId && newUser.user.userPublicId !== oldUser.user.userPublicId) || newUser.user.state !== "green") {
		folderData = null;
	}
}));


// 32 znaku hash orig
function generateId() {
	return Math.random().toString(16).replace("0.", "");
}

export function prepareSetting(setting: ESETTINGS_KEYS, value: boolean | number | string | IUserInitialPosition | Array<any> | IUserSpeedData): Pick<IUserSetting, "title" | "data" | "type"> {
	let data = {
		value: undefined,
		type: undefined,
	};

	switch (typeof value) {
		case "boolean":
			data = {
				value,
				type: "boolean",
			};
			break;

		case "string":
			data = {
				value,
				type: "string",
			};
			break;

		case "number":
			data = {
				value,
				type: "number",
			};
			break;

		case "object":
			if (Array.isArray(value)) {
				data = {
					value,
					type: "list",
				};
			} else {
				data = {
					value,
					type: "object",
				};
			}
			break;

		// tohle by nemelo nikdy nastat
		default:
			data = {
				value: value as any,
				type: "object",
			};
	}

	return {
		title: setting,
		data,
		type: "settings",
	};
}

export function setMapsetUserSettings(mapsetId: number, overlays?: Array<number>): Promise<void> {
	if (CONFIG.mapsetsBlackList.indexOf(getMapsetSeoById(mapsetId)) === -1) {
		const settingsMapset = prepareSetting(ESETTINGS_KEYS.MAPSET_WEB_LAST_ID, mapsetId);
		const settings = [settingsMapset];

		if (overlays) {
			settings.push(prepareSetting(ESETTINGS_KEYS.MAPSET_WEB_OVERLAYS, overlays));
		}

		return setUserSettings(settings);
	}

	return Promise.resolve();
}

export function setOverlaysUserSettings(overlays: Array<number>): Promise<void> {
	const settings = [prepareSetting(ESETTINGS_KEYS.MAPSET_WEB_OVERLAYS, overlays)];

	return setUserSettings(settings);
}

/**
 * Seznam uzivatelskeho hodnoceni.
 */
export function getUserSettings(): Promise<IUserSettingsResponse> {
	return frpc<IUserSettingsResponse>({
		url: CONFIG.requestUrl + OPTIONS.url,
		method: "settings.get",
		args: [Object.values(ESETTINGS_KEYS)],
	}).promise;
}

/**
 * Nastaveni uzivatelskeho hodnoceni.
 */
export function setUserSettings(newItem: Array<Pick<IUserSetting, "title" | "data">> | Pick<IUserSetting, "title" | "data">): Promise<void> {
	const settings = Array.isArray(newItem) ? newItem : [newItem];
	const hints = {};

	settings.forEach((setting, index) => {
		if (setting.title === ESETTINGS_KEYS.MAP_POSITION_WEB_DEFAULT) {
			const value = setting?.data?.value as IUserInitialPosition;

			if (value?.mark) {
				hints[`0.${index}.data.value.mark.lon`] = "float";
				hints[`0.${index}.data.value.mark.lat`] = "float";
			}

			// pracujeme s null, ale BE chce prazdny objekt
			if (value === null) {
				setting.data.value = {};
			}
		} else if (setting.title === ESETTINGS_KEYS.ROUTING_CRITERION_SPEED) {
			for (const criterion in settings[0].data.value as object) {
				hints[`0.${index}.data.value.${criterion}.value`] = "float";
			}
		}
	});

	return frpc<null>({
		url: CONFIG.requestUrl + OPTIONS.url,
		method: "settings.set",
		args: [settings],
		hints,
	}).promise;
}

export function getFolderData() {
	return folderData;
}

export function setFolderData(newFolderData: IFolderData) {
	folderData = newFolderData;
}

function debugOutput(data: any): Promise<any> {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			if (DEBUG_DATA.fail) {
				reject(data);
			} else {
				resolve(data);
			}
		}, DEBUG_DATA.timeout);
	});
}

// nevraci data
export function likeUpdate(id = "", like: Partial<ICreateLikeData> = {}, hints: ILikeHints = {}): Promise<IMapyBoxItem> {
	if (DEBUG_DATA.enabled) {
		console.log(["likeUpdate", id, like, hints]);

		return debugOutput({
			id,
			...like,
		});
	}

	return Mapy.ProviderMapyBox.likeUpdate(id, like, hints);
}

export function likeCreate(like: Partial<ICreateLikeData> = {}, hints: ILikeHints = {}, opts: ICreateLikeOpts = {}): Promise<IMapyBoxItem> {
	if (DEBUG_DATA.enabled) {
		console.log(["likeCreate", like, hints]);

		return debugOutput(like);
	}

	return Mapy.ProviderMapyBox.likeCreate(like, hints, opts);
}

export function likeMove(ids: Array<string> | string, parentId = "", opts: ILikeMoveOpts = {}): Promise<any> {
	if (DEBUG_DATA.enabled) {
		console.log(["likeMove", ids, parentId, opts]);

		return debugOutput({
			ids,
			parentId,
		});
	}

	return Mapy.ProviderMapyBox.likeMove(ids, parentId, opts);
}

export function getFolders(folderId = currentRootId, limitOnPage = LIMIT_ON_PAGE) {
	return Mapy.ProviderMapyBox.getFolders(folderId, null, limitOnPage);
}

// nevraci data
export function folderUpdate(id = "", folder: any = {}, hints = {}): Promise<IMapyBoxItem> {
	const userPublicId = store.getState().user.user.userPublicId;

	if (DEBUG_DATA.enabled) {
		console.log(["folderUpdate", id, folder, hints]);
		loadUserMymaps(userPublicId, true);

		return debugOutput({
			id,
			...folder,
		});
	}

	return Mapy.ProviderMapyBox.folderUpdate(id, folder, hints).then(() => {
		loadUserMymaps(userPublicId, true);
	}, () => {});
}

export function trackUpdate(tid = "", data: Partial<ICreateLikeData>): Promise<IMapyBoxItem> {
	if (DEBUG_DATA.enabled) {
		console.log(["trackUpdate", tid, data]);

		return debugOutput({
			id: tid,
			...data,
		});
	}

	return Mapy.ProviderMapyBox.trackUpdate(tid, data);
}

interface ITrackLinkChanges {
	usertitle?: string;
	description?: string;
	"data.info.trackType"?: TActivityType;
	user_time?: number;
}

export function trackLink(id = "", parent_id = "", changes: ITrackLinkChanges = {}): Promise<IMapyBoxItem> {
	if (DEBUG_DATA.enabled) {
		console.log(["trackLink", id, parent_id, changes]);

		return debugOutput({
			id,
			parent_id,
			changes,
		});
	}

	return Mapy.ProviderMapyBox.trackLink(id, parent_id, changes);
}

export function trackCopy(id = "", parent_id = "", usertitle = "", description = ""): Promise<ICopyOutput> {
	if (DEBUG_DATA.enabled) {
		console.log(["trackCopy", id, parent_id, usertitle, description]);

		return debugOutput({
			id,
			parent_id,
			usertitle,
			description
		});
	}

	return Mapy.ProviderMapyBox.trackCopy(id, parent_id, usertitle, description);
}

export function likeCopy(ids: Array<string>, parentId = ""): Promise<ICopyOutput> {
	if (DEBUG_DATA.enabled) {
		console.log(["likeCopy", ids, parentId, ids[0]]);

		return debugOutput({
			ids,
			parentId,
			copied: [{ new_id: ids[0] }],
		});
	}

	return Mapy.ProviderMapyBox.likeCopy(ids, parentId);
}

export function folderCopy(id = "", parentId = "", updateObj: { title?: string; description?: string; always_on_map?: boolean; } = {}): Promise<ICopyOutput> {
	if (DEBUG_DATA.enabled) {
		console.log(["folderCopy", id, parentId, updateObj]);

		return debugOutput({
			id,
			parentId,
			copied: [{ new_id: generateId() }],
			updateObj,
		});
	}

	return Mapy.ProviderMapyBox.folderCopy(id, parentId, updateObj);
}

export function trackDelete(tid: string): Promise<any> {
	if (DEBUG_DATA.enabled) {
		console.log(["trackDelete", tid]);

		return debugOutput({
			tid,
		});
	}

	return Mapy.ProviderMapyBox.trackDelete([tid]);
}

export function trackSort(sortType: TMyMapsSortOptions): Promise<any> {
	if (DEBUG_DATA.enabled) {
		console.log(["trackSort", sortType]);

		return debugOutput({
			sortType,
		});
	}

	return frpc({
		url: CONFIG.requestUrl + OPTIONS.url,
		method: "track.sort",
		args: [
			sortType
		],
	}).promise;
}

export function likeDelete(ids: Array<string> | string, opts: any = {}): Promise<any> {
	if (DEBUG_DATA.enabled) {
		console.log(["likeDelete", ids, opts]);

		return debugOutput({
			ids,
			opts,
		});
	}

	return Mapy.ProviderMapyBox.likeDelete(ids, opts);
}

interface IGetUserInfoData {
	user_id: string;
	user_source: "rus";
	root_id: string;
	folder_count: number;
	always_on_map_folders_count: number;
	always_on_map_items_count: number;
	status: number;
	statusMessage: "OK" | "error";
}

async function getMymapsInfo() {
	let mymapsInfo: IMyMapsState = null;

	try {
		const frpcData = await frpc<IGetUserInfoData>({
			url: CONFIG.requestUrl + OPTIONS.url,
			method: "getUserInfo",
			args: [],
		}).promise;

		if (frpcData.status === 200) {
			mymapsInfo = {
				rootId: frpcData.root_id,
				hasFolders: frpcData.folder_count > 0,
				alwaysOnMapFoldersCount: frpcData.always_on_map_folders_count,
				alwaysOnMapItemsCount: frpcData.always_on_map_items_count,
				openedFolderId: "",
			};
		}
	} catch (exc) {
		//
	}

	return mymapsInfo;
}

export async function loadUserMymaps(userPublicId: string, force = false) {
	let mymapsInfo: IMyMapsState = null;

	if (userPublicId) {
		if (force || !(userPublicId in userInfoCache)) {
			mymapsInfo = await getMymapsInfo();
		} else if (userInfoCache[userPublicId]) {
			mymapsInfo = userInfoCache[userPublicId];
		}
	}

	if (mymapsInfo) {
		currentRootId = mymapsInfo.rootId;
		// nacteme seznam slozek - do kese
		userInfoCache[userPublicId] = mymapsInfo;
		store.dispatch(mymapsSetFoldersData(mymapsInfo));
	} else {
		currentRootId = "";
		store.dispatch(mymapsClearData());
	}
}

function updateFolderCache() {
	Mapy.ProviderMapyBox.removeFolderFromCache(currentRootId);
	getFolders();
}

export function folderDelete(ids: Array<string> | string): Promise<any> {
	const userPublicId = store.getState().user.user.userPublicId;

	if (DEBUG_DATA.enabled) {
		console.log(["folderDelete", ids]);
		updateFolderCache();
		loadUserMymaps(userPublicId, true);

		return debugOutput({
			ids,
		});
	}

	return Mapy.ProviderMapyBox.folderDelete(ids).then(() => {
		updateFolderCache();
		loadUserMymaps(userPublicId, true);
	}, () => {});
}

export function folderCreate(title = "", parentId = "", alwaysOnMap = false): Promise<IMapyBoxItem> {
	const userPublicId = store.getState().user.user.userPublicId;

	if (DEBUG_DATA.enabled) {
		console.log(["folderCreate", title, parentId]);
		mymapsSetHasFolders();
		updateFolderCache();
		loadUserMymaps(userPublicId, true);

		return debugOutput({
			id: generateId(),
			title,
			parentId,
		});
	}

	return Mapy.ProviderMapyBox.folderCreate(title, parentId, alwaysOnMap).then(data => {
		mymapsSetHasFolders();
		updateFolderCache();
		loadUserMymaps(userPublicId, true);

		return data;
	}, () => {});
}

export interface ITrackListFolderItem {
	title: string;
	id: string;
	track_link_id: string;
	type: "root" | "folder";
}

interface ITrackListFoldersData {
	folders: Array<ITrackListFolderItem>;
	status: number;
}

export async function trackListFolders(id: string): Promise<ITrackListFoldersData["folders"]> {
	try {
		const frpcData = await frpc({
			url: CONFIG.requestUrl + OPTIONS.url,
			method: "track.listFolders",
			args: [id],
		}).promise as ITrackListFoldersData;

		if (frpcData.status === 200) {
			// seradime podle abecedy title
			frpcData.folders.sort((aItem, bItem) => bItem.title.localeCompare(aItem.title));

			return frpcData.folders;
		}
	} catch (exc) {
		//
	}

	return [];
}

export function alwaysOnMapLookup(viewport: { lbx: number; lby: number; rtx: number; rty: number }, {
	zoom,
}: { zoom: number }): Promise<any> {
	return frpc({
		url: CONFIG.requestUrl + OPTIONS.url,
		method: "alwaysOnMap.lookupbox",
		args: [
			viewport.lbx,
			viewport.lby,
			viewport.rtx,
			viewport.rty,
			{
				zoom,
				markerWidth: 32,
				markerHeight: 44,
			},
		],
		hints: {
			"0": "float",
			"1": "float",
			"2": "float",
			"3": "float",
			"4.zoom": "int",
			"4.markerWidth": "int",
			"4.markerHeight": "int",
		},
	}).promise;
}

export async function setMultipleVisited(ids: Array<string>, visited: boolean): Promise<{ error: string; }> {
	if (DEBUG_DATA.enabled) {
		console.log(["setMultipleVisited", ids, visited]);

		return debugOutput({
			error: "",
		});
	}

	const output = {
		error: "",
	};

	try {
		const frpcData = await frpc({
			url: CONFIG.requestUrl + OPTIONS.url,
			method: "like.updateMulti",
			args: [ids, {
				visited,
			}],
		}).promise;

		if (frpcData.status === 200) {
		} else {
			output.error = `Wrong status ${frpcData.status}`;
		}
	} catch (exc) {
		output.error = exc.message || exc.name || "Common exception";
	}

	return output;
}

// todo - nachystano nejspis pro Kraftaka
export async function getPoiLike(source: string, id: number): Promise<any> {
	return frpc({
		url: CONFIG.requestUrl + OPTIONS.url,
		method: "getPoiLike",
		args: [
			source, id,
		],
	}).promise;
}
